exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.watchlist-teaser[data-v-4cd5c087] {\n\tcursor: pointer;\n\tcolor: var(--q-color-primary);\n}\n", ""]);

